'use client';

import { c as _c } from "react/compiler-runtime";
import { useCollapse } from '@/uiComposites/interactive/Collapse';
import { useIsOpened } from '@/uiComposites/interactive/IsOpenedContext';
import { classes } from '@/uiPrimitives/base/classes.helpers';
import { ReactNode } from 'react';
import { meetingRowSubgrid } from './Meetings.css';
import { translateInline } from '@/globals/translate/translateInline';
import { shelf } from '@/uiPrimitives/layout/shelf';
import { occupy } from '@/uiPrimitives/layout/occupy';
import { indentSize } from '@/uiPrimitives/layout/indentSize.definitions';
import { icon } from '@/uiPrimitives/media/icon';
import { chevronIcon } from '@/uiIcons/chevronIcon.css';
import { textBlock, textStyle } from '@/uiPrimitives/typography/text';
import { addTestSelector } from '@/globals/testHelpers/testSelector';
import { unprintable } from '@/uiPrimitives/base/printable.css';
const getItemID = (id: string, index: number) => `${id}-${index}`;
const getAllItemIDs = (id: string, itemCount: number, alwaysShowCount: number) => {
  const itemIDs = [];
  for (let index = alwaysShowCount; index < itemCount; index++) {
    itemIDs.push(getItemID(id, index));
  }
  return itemIDs;
};
export const ShowMoreMeetingsLi = t0 => {
  const $ = _c(17);
  const {
    index,
    children
  } = t0;
  const {
    id,
    isOpened
  } = useIsOpened();
  const {
    outerProps,
    innerProps
  } = useCollapse(isOpened);
  let t1;
  if ($[0] !== outerProps.className) {
    t1 = classes(outerProps.className, meetingRowSubgrid);
    $[0] = outerProps.className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== id || $[3] !== index) {
    t2 = getItemID(id, index);
    $[2] = id;
    $[3] = index;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== innerProps.className) {
    t3 = classes(innerProps.className, meetingRowSubgrid);
    $[5] = innerProps.className;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = addTestSelector("uiMeetingRowHidden");
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== children || $[9] !== innerProps || $[10] !== t3) {
    t5 = <div {...innerProps} className={t3} {...t4}>{children}</div>;
    $[8] = children;
    $[9] = innerProps;
    $[10] = t3;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== outerProps || $[13] !== t1 || $[14] !== t2 || $[15] !== t5) {
    t6 = <li {...outerProps} className={t1} id={t2} tabIndex={-1}>{t5}</li>;
    $[12] = outerProps;
    $[13] = t1;
    $[14] = t2;
    $[15] = t5;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  return t6;
};
export const ShowMoreMeetingsButton = t0 => {
  const $ = _c(24);
  const {
    itemCount,
    alwaysShowCount,
    ...props
  } = t0;
  const {
    id,
    isOpened,
    setIsOpened
  } = useIsOpened();
  if (itemCount <= alwaysShowCount) {
    return null;
  }
  const itemIDs = getAllItemIDs(id, itemCount, alwaysShowCount);
  const t1 = () => {
    if (!isOpened) {
      document.getElementById(itemIDs[0])?.focus();
    }
    setIsOpened(_temp);
  };
  const t2 = itemIDs.join(" ");
  const t3 = classes(props.className, unprintable, shelf({}), textStyle({
    color: "positiveBlue",
    fontWeight: "bold"
  }));
  let t4;
  let t5;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = addTestSelector("uiShowMoreMeetingsButton");
    t5 = classes(textBlock({}));
    $[0] = t4;
    $[1] = t5;
  } else {
    t4 = $[0];
    t5 = $[1];
  }
  let t6;
  if ($[2] !== isOpened || $[3] !== itemIDs) {
    t6 = isOpened ? translateInline({
      en: "Less dates",
      nl: "Minder datums"
    }) : translateInline({
      en: `More dates (${itemIDs.length})`,
      nl: `Meer datums (${itemIDs.length})`
    });
    $[2] = isOpened;
    $[3] = itemIDs;
    $[4] = t6;
  } else {
    t6 = $[4];
  }
  let t7;
  if ($[5] !== t5 || $[6] !== t6) {
    t7 = <span className={t5}>{t6}</span>;
    $[5] = t5;
    $[6] = t6;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = classes(occupy({
      blockSize: "capSize",
      inlineSize: indentSize,
      alignItems: "end",
      justifyItems: "end"
    }));
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] !== isOpened) {
    t9 = classes(icon({
      icon: chevronIcon,
      adjustIcon: "rotate90deg",
      flip: isOpened ? "horizontal" : undefined,
      blockSize: "1ex"
    }));
    $[9] = isOpened;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  let t10;
  if ($[11] !== t9) {
    t10 = <i className={t9} />;
    $[11] = t9;
    $[12] = t10;
  } else {
    t10 = $[12];
  }
  let t11;
  if ($[13] !== t10 || $[14] !== t8) {
    t11 = <span className={t8}>{t10}</span>;
    $[13] = t10;
    $[14] = t8;
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  let t12;
  if ($[16] !== isOpened || $[17] !== props || $[18] !== t1 || $[19] !== t11 || $[20] !== t2 || $[21] !== t3 || $[22] !== t7) {
    t12 = <button {...props} onClick={t1} aria-controls={t2} aria-expanded={isOpened} className={t3} {...t4}>{t7}{t11}</button>;
    $[16] = isOpened;
    $[17] = props;
    $[18] = t1;
    $[19] = t11;
    $[20] = t2;
    $[21] = t3;
    $[22] = t7;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  return t12;
};
function _temp(oldIsOpened) {
  return !oldIsOpened;
}